import React, { useCallback, useContext, useEffect, useState } from 'react'
import { WrapDataGrid } from 'components/DataGrid/Style'
import { NormalizerContext } from './NormalizerContext'
import { assessmentsHooks } from 'pages/School/Assessments'
import { NormalizerStyles } from './Style'
import { VariableSizeList, FixedSizeList as List } from 'react-window';
import { Divider } from '@mui/material'
import { thirdly2 } from 'styles/theme'
import { LightButton, Space } from 'styles/GlobalStyle'
import { ApplyDataConfirmation, normalizerHooks } from '.'
import { changeItem } from 'utils/array'
import { ScoreRatingItem } from '.'
import { useQueryClient } from '@tanstack/react-query'
import { isEmpty, isEqual } from 'lodash'
import { EmptyScreen } from '.'
import { useAlert } from 'components/Alerts/hooks'
import { toastConfig } from 'config'
import { toast } from 'react-toastify'
import AssessmentFiltersHeader from 'pages/School/Assessments/AssessmentFiltersHeader'

const Normalizer = () => {
    const { assessmentCount, methods, applyDataConfirmOpen, setLoadingData, loadingData, setApplyDataConfirmOpen, activeScoreItemStatus, activeScoreRatingIndex, setActiveScoreRatingIndex, stats, setStats, scoreRatingOptions, setScoreRatingOptions, assessmentFilters, setAssessmentFilters, scoreRatingSemesters, checkType } = useContext(NormalizerContext)
    const headerItems = normalizerHooks.useCustomHeaderItems()
    const headerBtns = normalizerHooks.useHeaderBtns()
    const headerActionBtns = normalizerHooks.useHeaderActionBtns()
    const selectCheckType = normalizerHooks.useSelectCheckType()
    const queryClient = useQueryClient()
    const { setAlerts } = useAlert()

    const changeActiveScoreItem = useCallback((index) => {
        if (activeScoreRatingIndex != null && activeScoreItemStatus) {
            setApplyDataConfirmOpen(true)
        }
        else {
            if (isEqual(activeScoreRatingIndex, index))
                setActiveScoreRatingIndex(null)
            else {
                setActiveScoreRatingIndex(index)
                editScoreRatingOption(index, "showChildren")
            }
        }
    }, [activeScoreRatingIndex, activeScoreItemStatus])

    const editScoreRatingOption = useCallback((index, key) => {
        let scOptions = { ...scoreRatingOptions[index] }
        scOptions[key] = !scOptions[key]
        const nScoreRatingOptions = changeItem(scoreRatingOptions, index, scOptions)
        setScoreRatingOptions(nScoreRatingOptions)
    }, [scoreRatingOptions, stats])

    const refetchData = useCallback(async () => {
        setActiveScoreRatingIndex(null)
        setLoadingData(false)
        // queryClient.removeQueries({ queryKey: [checkType.queryKey] })
        await scoreRatingSemesters.refetch()
        // toast("הנתונים התעדכנו, אנא רפרש את העמוד, קריטי לביצועים!!! עד שנסדר את בעיית הביצועים", toastConfig)
        queryClient.invalidateQueries([checkType.queryKey])
    }, [checkType])

    const updateStats = useCallback((index, val) => {
        setStats(prevStats => {
            const nStats = changeItem(prevStats, index, val);
            return nStats;
        });
    }, [stats])

    useEffect(() => {
        return (() => {
            // queryClient.removeQueries()
            toast("כדאי לרפרש את העמוד בעת יציאה מהנורמלטור עד שנסדר את בעיית הביצועים", toastConfig)
        })
    }, [])

    useEffect(() => {
        return (() => {
            // if (activeScoreItemStatus == "view")
            //     setAlerts(alerts.exitNormalator, true)
        })
    }, [activeScoreItemStatus])

    const Row = ({ index, style }) => {
        const scoreRating = scoreRatingSemesters.data[index];
        return (
            <div style={style}>
                <ScoreRatingItem
                    key={index}
                    graphKey={index}
                    changeActiveScoreItem={changeActiveScoreItem}
                    activeScoreRatingIndex={activeScoreRatingIndex}
                    editScoreRatingOption={editScoreRatingOption}
                    index={index}
                    scoreRating={scoreRating}
                    scoreRatingOptions={scoreRatingOptions[index]}
                    stats={stats[index]}
                    updateStats={(val) => updateStats(index, val)}
                />
            </div>
        );
    };


    const disabledSearch =
        !checkType ||
        !assessmentFilters.category ||
        isEmpty(assessmentFilters.methods)

    return (
        <NormalizerStyles>
            <WrapDataGrid>
                <div className='header-items'>
                    <AssessmentFiltersHeader
                        keys={['categories']}
                        searchLabel="הצג"
                        disabledSearch={disabledSearch}
                        refetchData={refetchData}
                        loading={scoreRatingSemesters.isFetching}
                        headerItems={headerItems}
                        showLoading={true}
                        assessmentFilters={assessmentFilters}
                        setAssessmentFilters={setAssessmentFilters}
                    />
                    <div className='action-btns'>
                        {headerActionBtns?.map((actionBtn) =>
                            <LightButton
                                variant="solid"
                                size="small"
                                {...actionBtn}
                            />
                        )}
                    </div>
                </div>
                <Divider sx={{ borderColor: thirdly2 }} />
                <Space />
                {(checkType && !loadingData) ?
                    <div className='assessment-count'>
                        {!assessmentCount.data || `מציג נתונים של ${assessmentCount.data?.assessment_count} מבדקים שבוצעו על ידי  ${assessmentCount.data?.test_taker_count} תלמידים`}
                    </div> : null}
                <div className='sc-actions'>
                    <div className='sc-header-btns'>
                        {headerBtns.map((act, index) =>
                            <LightButton variant="solid" key={index} size="small" systemUI  {...act} />
                        )}
                    </div>
                </div>
                <Space />
                {/* {(checkType && !loadingData) ?
                    <div className='sc-sections'>
                        <List
                            height={700} // גובה התצוגה
                            itemCount={scoreRatingSemesters.data?.length || 0}
                            itemSize={260}
                            width={'100%'} // רוחב התצוגה
                        >
                            {Row}
                        </List>
                    </div>
                    :
                    <EmptyScreen />} */}
                {(checkType && !loadingData) ?
                    <div className='sc-sections'>
                        {scoreRatingSemesters.data?.map((scoreRating, index) => {

                            return (
                                <ScoreRatingItem
                                    key={index}
                                    changeActiveScoreItem={changeActiveScoreItem}
                                    activeScoreRatingIndex={activeScoreRatingIndex}
                                    graphKey={index}
                                    editScoreRatingOption={editScoreRatingOption}
                                    index={index}
                                    scoreRating={scoreRating}
                                    scoreRatingOptions={scoreRatingOptions[index]}
                                    stats={stats[index]}
                                    updateStats={(val) => updateStats(index, val)}
                                />
                            )
                        })}
                    </div> :
                    <EmptyScreen />
                }
                {/* {loadingData && <CircularProgress />} */}
            </WrapDataGrid >
            {applyDataConfirmOpen && <ApplyDataConfirmation handleAlert={setApplyDataConfirmOpen} />}
        </NormalizerStyles >
    )
}

export default Normalizer